var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEuroCircle32Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DD406C75-6A9B-43D2-8C50-8EDD0F53B3C6_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arveldus---Krediitkaart",
    transform: "translate(-241.000000, -199.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(208.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(33.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Euro-Circle_32px",
    transform: "translate(0.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,16 C32,24.8365565 24.8365565,32 16,32 C7.16344348,32 0,24.8365565 0,16 C0,7.16344348 7.16344348,0 16,0 C24.8365565,0 32,7.16344348 32,16 Z",
    id: "Stroke-1",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.594,24 C12.406,24 9,20.411 9,16 C9,11.589 12.406,8 16.594,8 C19.081,8 21.414,9.29 22.836,11.45 L21.164,12.55 C20.114,10.953 18.406,10 16.594,10 C13.51,10 11,12.691 11,16 C11,19.309 13.51,22 16.594,22 C18.406,22 20.115,21.047 21.164,19.45 L22.836,20.55 C21.414,22.709999 19.081,24 16.594,24 Z",
    id: "Fill-3",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#000000",
    points: "7 17 16 17 16 19 7 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#000000",
    points: "7 13 16 13 16 15 7 15"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEuroCircle32Px);
export default __webpack_public_path__ + "static/media/Icon_Euro-Circle_32px.5b89b9b8a5cf1f4966fcca4c117201e7.svg";
export { ForwardRef as ReactComponent };